export const EDIT_PROMO_CODE_DATES_MODAL_NAME =
  'EDIT_PROMO_CODE_DATES_MODAL_NAME';
